import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: ["data", "options", "labels"],
  mounted() {
    this.renderBarChart();
  },
  computed: {
    chartData: function() {
      return this.data;
    }
  },
  methods: {
    renderBarChart: function() {
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              data: this.chartData
            }
          ]
        },
        this.options
      );
    }
  },
  watch: {
    data: function() {
      this.renderBarChart();
    }
  }
};
